import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const nouvelEmployeur = {
	url: 'https://www.urssaf.fr/accueil/services/services-employeurs/premiere-embauche.html',
	title: "Nouvel employeur : l'Urssaf vous accompagne",
	description:
		'Première embauche, un service de l’Urssaf pour guider les nouveaux employeurs dans leurs démarches.',
	logo: URSSAF,
}
